// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand */}
        <div className="footer-brand" role="contentinfo">
          <h1 className="visually-hidden">UBR Engineering Works</h1>
          <h2>UBR Engineering Works</h2>
          <p>Delivering Precision, Power & Performance</p>
        </div>

        {/* Quick Links */}
        <nav className="footer-links" aria-label="Footer navigation">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#products">Products</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </nav>

        {/* Contact Info */}
        <div className="footer-contact">
          <h3>Contact</h3>
          <p>📞 <a href="tel:+919582417861" aria-label="Call us at +91 9582417861">+91 9582417861</a></p>
          <p>✉️ <a href="mailto:ubrenggworks@gmail.com" aria-label="Email us at ubrenggworks@gmail.com">ubrenggworks@gmail.com</a></p>
          <p>📍 Bhiwadi, Rajasthan</p>
        </div>
      </div>

      {/* Google Map */}
      <div className="footer-map" aria-label="Company Location on Map">
        <iframe
          title="UBR Engineering Works Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3518.3347252958833!2d76.8853588754827!3d28.13629667593937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d370008bf466d%3A0x993b27fbacb513a4!2sUBR%20ENGINEERING%20WORKS!5e0!3m2!1sen!2sin!4v1751530314074!5m2!1sen!2sin"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>&copy; 2025 UBR Engineering Works. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
